// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.12_webpack@5.109.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.12_webpack@5.109.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PC 端主题变量（digital-platform v2 全局唯一来源）。
 * 机制：html[data-theme="dark"] 切换变量值；自绘样式（host/插件/shared 组件）一律
 * 引用 var(--dp-*)，不写死颜色。AntD 组件由 ConfigProvider theme.algorithm 负责，
 * 此处变量取值与 antd 暗色 token 对齐（bgLayout #0f0f0f / bgContainer #141414 /
 * bgElevated #1f1f1f / text .85 白），保证自绘与 AntD 混排无色差断层。
 * 语义色（success/error 等品牌/状态色）两态一致，不进变量。
 */
:root {
  /* 内容区 chrome 总高（header 64 + main-content margin 32 + padding 48）：
     整页视图 calc(100vh - …) 的统一引用源；紧凑模式在下方覆盖为 108px */
  --dp-content-chrome: 144px;
  --dp-bg-layout: #f0f2f5;        /* 页面底（login 背景/内容区外圈） */
  --dp-bg-container: #ffffff;     /* 卡片/面板/表格底 */
  --dp-bg-elevated: #fafafa;      /* 输入框/hover 次级底 */
  --dp-bg-hover: rgba(0, 0, 0, 0.03);
  --dp-fill: #f5f5f5;             /* 三级填充（代码块底/灰条） */
  --dp-text: rgba(0, 0, 0, 0.88);
  --dp-text-secondary: rgba(0, 0, 0, 0.65);
  --dp-text-tertiary: rgba(0, 0, 0, 0.45); /* 提示/占位（原 #999） */
  --dp-primary: #1677ff;
  --dp-primary-bg: #e6f4ff;       /* 选中态浅底 */
  --dp-primary-border: #d6e4ff;
  --dp-success: #52c41a;
  --dp-success-bg: #f6ffed;
  --dp-error-bg: #fff1f0;
  --dp-warning-bg: #fff7e8;
  --dp-border: #f0f0f0;           /* 分隔线 */
  --dp-border-strong: #e8e8e8;    /* 输入框/卡片描边 */
  --dp-shadow: 0 1px 2px rgba(0, 0, 0, 0.03), 0 2px 8px rgba(0, 0, 0, 0.06);
  --dp-scroll-thumb: rgba(0, 0, 0, 0.25);
}

html[data-theme='dark'] {
  --dp-bg-layout: #0f0f0f;
  --dp-bg-container: #141414;
  --dp-bg-elevated: #1f1f1f;
  --dp-bg-hover: rgba(255, 255, 255, 0.06);
  --dp-fill: rgba(255, 255, 255, 0.08);
  --dp-text: rgba(255, 255, 255, 0.85);
  --dp-text-secondary: rgba(255, 255, 255, 0.65);
  --dp-text-tertiary: rgba(255, 255, 255, 0.45);
  --dp-primary: #1668dc;
  --dp-primary-bg: #111a2c;
  --dp-primary-border: #15325b;
  --dp-success: #49aa19;
  --dp-success-bg: #162312;
  --dp-error-bg: #2a1215;
  --dp-warning-bg: #2b2111;
  --dp-border: #262626;
  --dp-border-strong: #303030;
  --dp-shadow: 0 1px 2px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.5);
  --dp-scroll-thumb: rgba(255, 255, 255, 0.25);
}

/* 全局底色跟随（body 兜底，防止滚动露白） */
body {
  background: var(--dp-bg-layout);
  color: var(--dp-text);
}

/* ── 全局弹窗紧凑边距（2026-10-18 用户需求：antd 默认 16px 20px 四周浪费）──
   覆盖 ConfigProvider :where token（0 特异性，:where(.css-*) 规则无需 !important，
   此处 class 选择器特异性更高自然胜出；antd 4.x 弹窗统一 .ant-modal-content 内边距）。 */
.ant-modal .ant-modal-content { padding: 10px 14px; }
.ant-modal .ant-modal-header { margin-bottom: 8px; }
.ant-modal .ant-modal-body { padding: 0; }

/* ╔══ 全局紧凑外观（2026-10-18 用户需求：全站统一开关，非单页局部）══╗
 * 开关：MainLayout header 压缩图标（stores/compact.js，localStorage dp_compact）。
 * 生效机制：antd 组件 token 派生不参与（compactAlgorithm 与 default 算法链式
 * 组合失效——default 派生 (token) 忽略上游 mapToken，见 App.vue 注释），
 * 全部密度调整走本文件 html[data-compact='1'] 全局规则（全局选择器命中所有
 * bundle 的 DOM，无论哪个 MF remote 渲染）：布局边距、控件定高、弹窗、
 * chat-ui 自绘组件密度。
 * 注意：html[data-compact] 由 stores/compact.js 的 watchEffect 维护。 */

/* 布局骨架：内容区边距/内边距减半（24+16 → 10+12）——非 flush 页全部受益 */
html[data-compact='1'] .main-content {
  margin: 10px;
  padding: 12px;
}
/* 整页视图 chrome 高度同步收紧（64 + 10×2 + 12×2 = 108px）——
   calc(100vh - var(--dp-content-chrome)) 的页面自动跟随，不再溢出 */
html[data-compact='1'] {
  --dp-content-chrome: 108px;
}
/* antd 控件密度直接定高（2026-10-18 务实方案，替代 compactAlgorithm——见 App.vue
   注释：default 派生忽略上游 mapToken，算法链式组合在浅色下失效）。
   尺寸格：middle 32→28、large 40→36、small 24 不动（再小伤可读性）。
   antd 规则均为 :where(.css-*) 零特异性，html[data-compact] 前缀必然胜出；
   不加 !important——autosize textarea 的行内高度优先于样式表，天然不受误伤。 */
html[data-compact='1'] .ant-btn:not(.ant-btn-sm):not(.ant-btn-lg) {
  height: 28px;
  padding-inline: 10px;
  font-size: 13px;
}
html[data-compact='1'] .ant-btn.ant-btn-lg {
  height: 36px;
}
/* 单行输入类控件同档 28px（textarea 的 autosize 行内高度不受影响） */
html[data-compact='1'] .ant-input {
  height: 28px;
}
html[data-compact='1'] textarea.ant-input {
  height: auto; /* 多行输入由 autosize 行内值决定，此行仅解除上行误伤 */
}
/* 带前缀/后缀/清除钮的输入框（.ant-input-affix-wrapper，实测 2026-10-20 被漏）：
   wrapper 自身定高 28，内层 input 跟 26（antd 默认 wrapper 32+input 32 → 视觉大框） */
html[data-compact='1'] .ant-input-affix-wrapper:not(textarea) {
  height: 28px;
  padding-block: 0;
}
html[data-compact='1'] .ant-input-affix-wrapper > input.ant-input {
  height: 26px;
}
/* 多选下拉（mode=multiple；2026-10-20 实测漏网：tag 24px 撑到 32px）：
   selector 定高 28 + tag 压到 20px（antd small 档高度），空态搜索框同步 */
html[data-compact='1'] .ant-select-multiple .ant-select-selector {
  min-height: 26px;
  height: 28px;
  padding-top: 1px;
  padding-bottom: 1px;
}
html[data-compact='1'] .ant-select-multiple .ant-select-selection-item {
  height: 20px;
  line-height: 18px;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 12px;
}
html[data-compact='1'] .ant-select-multiple .ant-select-selection-search-input {
  height: 20px;
}
html[data-compact='1'] .ant-select-single .ant-select-selector {
  height: 28px;
}
html[data-compact='1'] .ant-select-single .ant-select-selector .ant-select-selection-item,
html[data-compact='1'] .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 26px;
}
html[data-compact='1'] .ant-picker {
  height: 28px;
}
/* 分页器行高 */
html[data-compact='1'] .ant-pagination .ant-pagination-item {
  height: 28px;
  line-height: 26px;
}
/* 分页/标签等行内小组件行距收紧 */
html[data-compact='1'] .ant-pagination {
  margin-top: 8px;
}
/* 弹窗在紧凑模式再紧一档（10 14 → 6 10）+ 标题行压缩 */
html[data-compact='1'] .ant-modal .ant-modal-content { padding: 6px 10px; }
html[data-compact='1'] .ant-modal .ant-modal-header { margin-bottom: 4px; }
html[data-compact='1'] .ant-modal .ant-modal-title { font-size: 14px; }

/* ── chat-ui 共享组件（编排对话页/任务详情/悬浮对话全用这套）──
 * 类名来自 web/shared/chat-ui（MessageStream/ChatComposer/ConversationComments）。
 * 插件各带一份 bundle，scoped 样式无法跨 bundle，全局选择器是唯一通路。 */

/* MessageStream 侧边工具条：圆钮 32→26px */
html[data-compact='1'] .stream-tools .tool-btn {
  width: 26px;
  height: 26px;
  font-size: 12px;
}
/* ChatComposer 输入区：列间距 8→4、状态行高度压缩 */
html[data-compact='1'] .composer {
  gap: 4px;
}
html[data-compact='1'] .composer-status {
  min-height: 14px;
  font-size: 11px;
}
html[data-compact='1'] .composer-actions .ant-btn {
  padding-inline: 8px;
}
/* 任务详情头部区（orchestrator TaskDetail，编排对话页主体）：meta 条/按钮行间距再压 */
html[data-compact='1'] .detail .head-zone .meta-bar {
  padding: 2px 6px;
}
html[data-compact='1'] .detail .actions {
  gap: 6px;
  padding-top: 4px;
}
/* 聊天工具条（chat-area 顶部）：行高压缩 */
html[data-compact='1'] .chat-toolbar {
  padding: 2px 6px;
  gap: 4px;
}
html[data-compact='1'] .chat-toolbar .ant-btn {
  padding-inline: 6px;
}
/* 消息流整体内边距收紧（16→8px）——scoped 选择器打不到跨 bundle，全局命中 */
html[data-compact='1'] .msg-stream {
  padding: 8px;
}
/* meta 行（时间+复制）与正文间距 4→2px；meta 自身 11px 字号不变保可读 */
html[data-compact='1'] .msg-stream .msg-meta {
  margin-top: 2px;
}

/* ╔══ 悬浮球置顶体系（2026-10-11 重构，取代 2026-10-07 的退层方案）══╗
 * 用户裁决：弹窗（git/diff/查看文件等）打开时，右下角入口球必须仍可见可点
 * （开着 Git 弹窗还要点对话球问问题）。方案从「弹窗开→球退 999」反转为
 * 「球常驻 2000 置顶，压过 antd 全部弹窗层」：
 *   - 容器层：.fl-root(FloatingChat) / .gw-root(GitStatusWidget) /
 *     .fw-root(FilesWidget) 均 2000；FloatFab 球体与 float-kit FloatPanel 同步 2000
 *   - 球唤起的弹窗（Git 状态等）仍走 antd 1000/1100 层，在球之下——符合预期
 *   - 球体小（48px 固定右下角），盖住弹窗遮罩不构成遮挡伤害；面板打开时
 *     对应球 v-if 隐藏（原设计），互不叠压
 * 旧退层规则（body:has(.ant-modal-mask…) → 999）已删除：它会在任何弹窗
 * 打开时把 2000 打回 999，直接抵消置顶——即「球被弹窗遮挡」的根因。
 * Drawer(1000) 场景不变：球 2000 恒压 Drawer，任务详情抽屉开着照常可用。 */

`, "",{"version":3,"sources":["webpack://./src/theme.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;EACE;mDACiD;EACjD,0BAA0B;EAC1B,uBAAuB,SAAS,wBAAwB;EACxD,0BAA0B,MAAM,cAAc;EAC9C,yBAAyB,OAAO,kBAAkB;EAClD,kCAAkC;EAClC,kBAAkB,cAAc,kBAAkB;EAClD,8BAA8B;EAC9B,wCAAwC;EACxC,uCAAuC,EAAE,kBAAkB;EAC3D,qBAAqB;EACrB,wBAAwB,QAAQ,UAAU;EAC1C,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB,YAAY,QAAQ;EACxC,2BAA2B,KAAK,aAAa;EAC7C,yEAAyE;EACzE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,wCAAwC;EACxC,oCAAoC;EACpC,oCAAoC;EACpC,8CAA8C;EAC9C,6CAA6C;EAC7C,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,uEAAuE;EACvE,4CAA4C;AAC9C;;AAEA,2BAA2B;AAC3B;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;iEAEiE;AACjE,gCAAgC,kBAAkB,EAAE;AACpD,+BAA+B,kBAAkB,EAAE;AACnD,6BAA6B,UAAU,EAAE;;AAEzC;;;;;;;gEAOgE;;AAEhE,mDAAmD;AACnD;EACE,YAAY;EACZ,aAAa;AACf;AACA;wDACwD;AACxD;EACE,0BAA0B;AAC5B;AACA;;;;yDAIyD;AACzD;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA,iDAAiD;AACjD;EACE,YAAY;AACd;AACA;EACE,YAAY,EAAE,mCAAmC;AACnD;AACA;sEACsE;AACtE;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;yDACyD;AACzD;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA,UAAU;AACV;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA,oBAAoB;AACpB;EACE,eAAe;AACjB;AACA,qCAAqC;AACrC,uDAAuD,iBAAiB,EAAE;AAC1E,sDAAsD,kBAAkB,EAAE;AAC1E,qDAAqD,eAAe,EAAE;;AAEtE;;kDAEkD;;AAElD,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA,4DAA4D;AAC5D;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,gBAAgB;AAClB;AACA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA,mDAAmD;AACnD;EACE,YAAY;AACd;AACA,kDAAkD;AAClD;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;qDAWqD","sourcesContent":["/* PC 端主题变量（digital-platform v2 全局唯一来源）。\n * 机制：html[data-theme=\"dark\"] 切换变量值；自绘样式（host/插件/shared 组件）一律\n * 引用 var(--dp-*)，不写死颜色。AntD 组件由 ConfigProvider theme.algorithm 负责，\n * 此处变量取值与 antd 暗色 token 对齐（bgLayout #0f0f0f / bgContainer #141414 /\n * bgElevated #1f1f1f / text .85 白），保证自绘与 AntD 混排无色差断层。\n * 语义色（success/error 等品牌/状态色）两态一致，不进变量。\n */\n:root {\n  /* 内容区 chrome 总高（header 64 + main-content margin 32 + padding 48）：\n     整页视图 calc(100vh - …) 的统一引用源；紧凑模式在下方覆盖为 108px */\n  --dp-content-chrome: 144px;\n  --dp-bg-layout: #f0f2f5;        /* 页面底（login 背景/内容区外圈） */\n  --dp-bg-container: #ffffff;     /* 卡片/面板/表格底 */\n  --dp-bg-elevated: #fafafa;      /* 输入框/hover 次级底 */\n  --dp-bg-hover: rgba(0, 0, 0, 0.03);\n  --dp-fill: #f5f5f5;             /* 三级填充（代码块底/灰条） */\n  --dp-text: rgba(0, 0, 0, 0.88);\n  --dp-text-secondary: rgba(0, 0, 0, 0.65);\n  --dp-text-tertiary: rgba(0, 0, 0, 0.45); /* 提示/占位（原 #999） */\n  --dp-primary: #1677ff;\n  --dp-primary-bg: #e6f4ff;       /* 选中态浅底 */\n  --dp-primary-border: #d6e4ff;\n  --dp-success: #52c41a;\n  --dp-success-bg: #f6ffed;\n  --dp-error-bg: #fff1f0;\n  --dp-warning-bg: #fff7e8;\n  --dp-border: #f0f0f0;           /* 分隔线 */\n  --dp-border-strong: #e8e8e8;    /* 输入框/卡片描边 */\n  --dp-shadow: 0 1px 2px rgba(0, 0, 0, 0.03), 0 2px 8px rgba(0, 0, 0, 0.06);\n  --dp-scroll-thumb: rgba(0, 0, 0, 0.25);\n}\n\nhtml[data-theme='dark'] {\n  --dp-bg-layout: #0f0f0f;\n  --dp-bg-container: #141414;\n  --dp-bg-elevated: #1f1f1f;\n  --dp-bg-hover: rgba(255, 255, 255, 0.06);\n  --dp-fill: rgba(255, 255, 255, 0.08);\n  --dp-text: rgba(255, 255, 255, 0.85);\n  --dp-text-secondary: rgba(255, 255, 255, 0.65);\n  --dp-text-tertiary: rgba(255, 255, 255, 0.45);\n  --dp-primary: #1668dc;\n  --dp-primary-bg: #111a2c;\n  --dp-primary-border: #15325b;\n  --dp-success: #49aa19;\n  --dp-success-bg: #162312;\n  --dp-error-bg: #2a1215;\n  --dp-warning-bg: #2b2111;\n  --dp-border: #262626;\n  --dp-border-strong: #303030;\n  --dp-shadow: 0 1px 2px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.5);\n  --dp-scroll-thumb: rgba(255, 255, 255, 0.25);\n}\n\n/* 全局底色跟随（body 兜底，防止滚动露白） */\nbody {\n  background: var(--dp-bg-layout);\n  color: var(--dp-text);\n}\n\n/* ── 全局弹窗紧凑边距（2026-10-18 用户需求：antd 默认 16px 20px 四周浪费）──\n   覆盖 ConfigProvider :where token（0 特异性，:where(.css-*) 规则无需 !important，\n   此处 class 选择器特异性更高自然胜出；antd 4.x 弹窗统一 .ant-modal-content 内边距）。 */\n.ant-modal .ant-modal-content { padding: 10px 14px; }\n.ant-modal .ant-modal-header { margin-bottom: 8px; }\n.ant-modal .ant-modal-body { padding: 0; }\n\n/* ╔══ 全局紧凑外观（2026-10-18 用户需求：全站统一开关，非单页局部）══╗\n * 开关：MainLayout header 压缩图标（stores/compact.js，localStorage dp_compact）。\n * 生效机制：antd 组件 token 派生不参与（compactAlgorithm 与 default 算法链式\n * 组合失效——default 派生 (token) 忽略上游 mapToken，见 App.vue 注释），\n * 全部密度调整走本文件 html[data-compact='1'] 全局规则（全局选择器命中所有\n * bundle 的 DOM，无论哪个 MF remote 渲染）：布局边距、控件定高、弹窗、\n * chat-ui 自绘组件密度。\n * 注意：html[data-compact] 由 stores/compact.js 的 watchEffect 维护。 */\n\n/* 布局骨架：内容区边距/内边距减半（24+16 → 10+12）——非 flush 页全部受益 */\nhtml[data-compact='1'] .main-content {\n  margin: 10px;\n  padding: 12px;\n}\n/* 整页视图 chrome 高度同步收紧（64 + 10×2 + 12×2 = 108px）——\n   calc(100vh - var(--dp-content-chrome)) 的页面自动跟随，不再溢出 */\nhtml[data-compact='1'] {\n  --dp-content-chrome: 108px;\n}\n/* antd 控件密度直接定高（2026-10-18 务实方案，替代 compactAlgorithm——见 App.vue\n   注释：default 派生忽略上游 mapToken，算法链式组合在浅色下失效）。\n   尺寸格：middle 32→28、large 40→36、small 24 不动（再小伤可读性）。\n   antd 规则均为 :where(.css-*) 零特异性，html[data-compact] 前缀必然胜出；\n   不加 !important——autosize textarea 的行内高度优先于样式表，天然不受误伤。 */\nhtml[data-compact='1'] .ant-btn:not(.ant-btn-sm):not(.ant-btn-lg) {\n  height: 28px;\n  padding-inline: 10px;\n  font-size: 13px;\n}\nhtml[data-compact='1'] .ant-btn.ant-btn-lg {\n  height: 36px;\n}\n/* 单行输入类控件同档 28px（textarea 的 autosize 行内高度不受影响） */\nhtml[data-compact='1'] .ant-input {\n  height: 28px;\n}\nhtml[data-compact='1'] textarea.ant-input {\n  height: auto; /* 多行输入由 autosize 行内值决定，此行仅解除上行误伤 */\n}\n/* 带前缀/后缀/清除钮的输入框（.ant-input-affix-wrapper，实测 2026-10-20 被漏）：\n   wrapper 自身定高 28，内层 input 跟 26（antd 默认 wrapper 32+input 32 → 视觉大框） */\nhtml[data-compact='1'] .ant-input-affix-wrapper:not(textarea) {\n  height: 28px;\n  padding-block: 0;\n}\nhtml[data-compact='1'] .ant-input-affix-wrapper > input.ant-input {\n  height: 26px;\n}\n/* 多选下拉（mode=multiple；2026-10-20 实测漏网：tag 24px 撑到 32px）：\n   selector 定高 28 + tag 压到 20px（antd small 档高度），空态搜索框同步 */\nhtml[data-compact='1'] .ant-select-multiple .ant-select-selector {\n  min-height: 26px;\n  height: 28px;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\nhtml[data-compact='1'] .ant-select-multiple .ant-select-selection-item {\n  height: 20px;\n  line-height: 18px;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 12px;\n}\nhtml[data-compact='1'] .ant-select-multiple .ant-select-selection-search-input {\n  height: 20px;\n}\nhtml[data-compact='1'] .ant-select-single .ant-select-selector {\n  height: 28px;\n}\nhtml[data-compact='1'] .ant-select-single .ant-select-selector .ant-select-selection-item,\nhtml[data-compact='1'] .ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  line-height: 26px;\n}\nhtml[data-compact='1'] .ant-picker {\n  height: 28px;\n}\n/* 分页器行高 */\nhtml[data-compact='1'] .ant-pagination .ant-pagination-item {\n  height: 28px;\n  line-height: 26px;\n}\n/* 分页/标签等行内小组件行距收紧 */\nhtml[data-compact='1'] .ant-pagination {\n  margin-top: 8px;\n}\n/* 弹窗在紧凑模式再紧一档（10 14 → 6 10）+ 标题行压缩 */\nhtml[data-compact='1'] .ant-modal .ant-modal-content { padding: 6px 10px; }\nhtml[data-compact='1'] .ant-modal .ant-modal-header { margin-bottom: 4px; }\nhtml[data-compact='1'] .ant-modal .ant-modal-title { font-size: 14px; }\n\n/* ── chat-ui 共享组件（编排对话页/任务详情/悬浮对话全用这套）──\n * 类名来自 web/shared/chat-ui（MessageStream/ChatComposer/ConversationComments）。\n * 插件各带一份 bundle，scoped 样式无法跨 bundle，全局选择器是唯一通路。 */\n\n/* MessageStream 侧边工具条：圆钮 32→26px */\nhtml[data-compact='1'] .stream-tools .tool-btn {\n  width: 26px;\n  height: 26px;\n  font-size: 12px;\n}\n/* ChatComposer 输入区：列间距 8→4、状态行高度压缩 */\nhtml[data-compact='1'] .composer {\n  gap: 4px;\n}\nhtml[data-compact='1'] .composer-status {\n  min-height: 14px;\n  font-size: 11px;\n}\nhtml[data-compact='1'] .composer-actions .ant-btn {\n  padding-inline: 8px;\n}\n/* 任务详情头部区（orchestrator TaskDetail，编排对话页主体）：meta 条/按钮行间距再压 */\nhtml[data-compact='1'] .detail .head-zone .meta-bar {\n  padding: 2px 6px;\n}\nhtml[data-compact='1'] .detail .actions {\n  gap: 6px;\n  padding-top: 4px;\n}\n/* 聊天工具条（chat-area 顶部）：行高压缩 */\nhtml[data-compact='1'] .chat-toolbar {\n  padding: 2px 6px;\n  gap: 4px;\n}\nhtml[data-compact='1'] .chat-toolbar .ant-btn {\n  padding-inline: 6px;\n}\n/* 消息流整体内边距收紧（16→8px）——scoped 选择器打不到跨 bundle，全局命中 */\nhtml[data-compact='1'] .msg-stream {\n  padding: 8px;\n}\n/* meta 行（时间+复制）与正文间距 4→2px；meta 自身 11px 字号不变保可读 */\nhtml[data-compact='1'] .msg-stream .msg-meta {\n  margin-top: 2px;\n}\n\n/* ╔══ 悬浮球置顶体系（2026-10-11 重构，取代 2026-10-07 的退层方案）══╗\n * 用户裁决：弹窗（git/diff/查看文件等）打开时，右下角入口球必须仍可见可点\n * （开着 Git 弹窗还要点对话球问问题）。方案从「弹窗开→球退 999」反转为\n * 「球常驻 2000 置顶，压过 antd 全部弹窗层」：\n *   - 容器层：.fl-root(FloatingChat) / .gw-root(GitStatusWidget) /\n *     .fw-root(FilesWidget) 均 2000；FloatFab 球体与 float-kit FloatPanel 同步 2000\n *   - 球唤起的弹窗（Git 状态等）仍走 antd 1000/1100 层，在球之下——符合预期\n *   - 球体小（48px 固定右下角），盖住弹窗遮罩不构成遮挡伤害；面板打开时\n *     对应球 v-if 隐藏（原设计），互不叠压\n * 旧退层规则（body:has(.ant-modal-mask…) → 999）已删除：它会在任何弹窗\n * 打开时把 2000 打回 999，直接抵消置顶——即「球被弹窗遮挡」的根因。\n * Drawer(1000) 场景不变：球 2000 恒压 Drawer，任务详情抽屉开着照常可用。 */\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
